"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JoinInteractionHandler = void 0;
const tslib_1 = require("tslib");
const rxjs_1 = require("rxjs");
const uuid_1 = require("uuid");
const MessageType_1 = require("../message/MessageType");
const Util_1 = require("../shared/Util");
const IResult_1 = require("../shared/IResult");
const Error_1 = require("../shared/Error");
const EndpointType_1 = require("../endpoint/EndpointType");
class JoinInteractionHandler {
    constructor(router, messagingClient, joinService, channelID) {
        this.router = router;
        this.messagingClient = messagingClient;
        this.joinService = joinService;
        this.channelID = channelID;
        this.joinObservable = new rxjs_1.Subject();
        this.router.setHandler(MessageType_1.MessageType.JoinInteractionResponse, this);
    }
    joinInteraction(entersektJoinCode) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const message = {
                messageName: MessageType_1.MessageType.JoinInteractionRequest,
                payload: {
                    inboundMessageID: (0, uuid_1.v4)(),
                    endpoint: {
                        entersektJoinCode,
                        channelID: this.channelID,
                        //TODO: Implement endpointID from browser ID
                        endpointID: (0, uuid_1.v4)(),
                        type: EndpointType_1.EndpointType.BROWSER,
                    },
                },
            };
            this.messagingClient.send(message);
            const promise = (0, rxjs_1.firstValueFrom)(this.joinObservable);
            yield Util_1.Util.promiseWithTimeout(promise);
            this.router.removeHandler(MessageType_1.MessageType.JoinInteractionResponse);
            this.joinService.setJoinCode(entersektJoinCode);
            return Promise.resolve();
        });
    }
    handle(message) {
        if (this.isJoinInteractionResponse(message)) {
            if (message.payload.result.action === IResult_1.Action.APPROVED) {
                this.joinObservable.next();
            }
            else {
                this.joinObservable.error(Error_1.CustomerAuthnError.JOIN_ERROR);
            }
        }
        else {
            this.joinObservable.error(Error_1.CustomerAuthnError.MALFORMED_MESSAGE);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isJoinInteractionResponse(object) {
        return (object.payload instanceof Object &&
            "payload" in object &&
            "inboundMessageID" in object.payload &&
            "messageID" in object.payload &&
            "result" in object.payload &&
            object.payload.result instanceof Object &&
            "action" in object.payload.result);
    }
}
exports.JoinInteractionHandler = JoinInteractionHandler;
//# sourceMappingURL=JoinInteractionHandler.js.map